import { reduxForm } from 'redux-form';
// import Component from '../FormBlockedNik/Component';
import Component from './FilterMerchantForm';
import validate from './validate';

const initialValues = {
  field: '',
  search: '',
};

const FilterMerchantForm = reduxForm({
  form: 'filterMerchantForm',
  initialValues,
  enableReinitialize: true,
  validate,
})(Component);

export default FilterMerchantForm;
